export const customer_activity_form_data = {
  offering_name: { field: "title", placeHolder: "Offering name" },
  offering_type: { field: "type", placeHolder: "Offering type" },
  offering_owner: { field: "staff_name", placeHolder: "Offering owners" },
  status: { field: "status", placeHolder: "Activity" },
  date: { field: "created_at", placeHolder: "Date/Time" },
};
